// Credit purchase constants
export const CREDIT_PURCHASE_DEFAULTS = {
	AMOUNT: 200,
} as const;

export const CREDIT_PURCHASE_LIMITS = {
	MIN: 1,
	MAX: 1e5,
	STEP: 25,
} as const;
